import { Badge } from '@/components/shadcn/badge'
import { JsonTableCell } from '@/components/ui/DataTable/JsonTableCell'
import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { format as formatDate } from 'date-fns'

type FailedLoginEntry = RestSchemas['Messages.Support.FailedLoginEntry']

export const columns: ColumnDef<FailedLoginEntry>[] = [
  {
    id: 'createdAt',
    accessorKey: 'createdAt',
    header: ({ column }) => <SortingHeaderButton column={column}>Date & Time</SortingHeaderButton>,
    cell: ({ row }) => (
      <div className="flex justify-start">
        <div className="flex flex-col items-end">
          <div>
            <Badge variant="secondary" className="h-4 font-normal text-foreground">
              {row.original.createdAt ? formatDate(row.original.createdAt, 'PP') : ''}
            </Badge>
          </div>
          <div>
            <Badge variant="outline" className="h-4 font-normal">
              {row.original.createdAt ? formatDate(row.original.createdAt, 'p') : ''}
            </Badge>
          </div>
        </div>
      </div>
    ),
    sortingFn: (rowA, rowB) =>
      rowA.original.createdAt ? rowA.original.createdAt.localeCompare(rowB.original.createdAt ?? '') : 0,
  },
  {
    id: 'email',
    accessorKey: 'email',
    header: ({ column }) => <SortingHeaderButton column={column}>Email</SortingHeaderButton>,
    cell: ({ row }) => <span className="font-mono text-sm">{row.original.email ?? '-'}</span>,
    sortingFn: (rowA, rowB) => (rowA.original.email ?? '').localeCompare(rowB.original.email ?? ''),
  },
  {
    id: 'rejectionReason',
    accessorKey: 'rejectionReason',
    header: ({ column }) => <SortingHeaderButton column={column}>Rejection Reason</SortingHeaderButton>,
    cell: ({ row }) => (
      <Badge variant="destructive" className="font-normal">
        {row.original.rejectionReason ?? ''}
      </Badge>
    ),
    sortingFn: (rowA, rowB) =>
      (rowA.original.rejectionReason ?? '').localeCompare(rowB.original.rejectionReason ?? ''),
  },
  {
    id: 'authResponse',
    accessorKey: 'authResponse',
    header: 'Auth Response',
    cell: ({ row }) => <JsonTableCell value={row.original.authResponse} emptyLabel="-" />,
    enableSorting: false,
    size: 220,
    minSize: 180,
  },
]
